import React from 'react';
import { Loader2 } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'shadcn/components/ui/Card';
import { Input } from 'shadcn/components/ui/Input';
import { Label } from 'shadcn/components/ui/Label';

/**
 * @param {Object} props
 * @param {string} props.shipmentIdInput
 * @param {(value: string) => void} props.onShipmentIdInputChange
 * @param {(event: React.FormEvent) => void} props.onSubmit
 * @param {boolean} props.isLookingUp
 */
function MispickShipmentLookup({ isLookingUp, onShipmentIdInputChange, onSubmit, shipmentIdInput }) {
    return (
        <Card>
            <CardHeader>
                <CardTitle>Find shipment</CardTitle>
                <CardDescription>Enter the shipment ID to load unpicked items.</CardDescription>
            </CardHeader>
            <CardContent>
                <form onSubmit={onSubmit} className="flex flex-col gap-4 sm:flex-row sm:items-end">
                    <div className="grid w-full max-w-xs gap-2">
                        <Label htmlFor="mispick-shipment-id">Shipment ID</Label>
                        <Input
                            id="mispick-shipment-id"
                            inputMode="numeric"
                            value={shipmentIdInput}
                            onChange={(e) => onShipmentIdInputChange(e.target.value)}
                            placeholder="e.g. 200001"
                            autoComplete="off"
                        />
                    </div>
                    <Button type="submit" disabled={isLookingUp}>
                        {isLookingUp ? (
                            <>
                                <Loader2 className="animate-spin" aria-hidden />
                                Looking up…
                            </>
                        ) : (
                            'Look Up'
                        )}
                    </Button>
                </form>
            </CardContent>
        </Card>
    );
}

export { MispickShipmentLookup };
